import { ArrowBack, Home } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PageNotFound({ fullWidth = true }: { fullWidth?: boolean }) {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={fullWidth ? "100vh" : "60vh"}
      gap={3}
      sx={{ 
        bgcolor: 'background.default',
        px: 3,
        textAlign: 'center'
      }}
    >
      <Typography 
        variant="h1" 
        sx={{ 
          fontSize: { xs: 80, md: 120 },
          fontWeight: 'bold',
          color: 'primary.main',
          textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        404
      </Typography>
      
      <Stack spacing={2} alignItems="center" maxWidth={500}>
        <Typography variant="h4" fontWeight="bold" color="text.primary">
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary">
          The page you're looking for doesn't exist or has been moved. 
          Please check the URL or navigate back to safety.
        </Typography>
        
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3 }}>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            startIcon={<ArrowBack />}
          >
            Go Back
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/')}
            startIcon={<Home />}
          >
            Go Home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
